const locale = {
    ERROR: "Error",
    SUCCESS: "Erfolg",
	UNKNOWNERROR: "Unbekannter Fehler",
    SERVERBADRESPONSE: "Ungültige Antwort vom Server erhalten",
    SESSIONEXPIRED: "Sitzung ist abgelaufen",
    EMPTYVALUE: "Leerer Wert",
    ERROR_GENERAL: "Genereller Fehler",
    ERROR_ESTABLISHCONNECTION: "Fehler beim Aufbau einer sicheren Verbindung",
    ERROR_PROCESSINGDATA: "Fehler beim Verarbeiten der Daten",
    ERROR_COMMUNICATIONWITHSERVER: "Fehler bei der Kommunikation mit dem Server",
};

export default locale;
